module.exports = __webpack_public_path__ + "img/img_1.3387dba5.jpg";